import UserDetails from 'types/userDetails';

// Class to parse contents of CSV file, assuming header columns
// 'firstName', 'lastName', and 'email'.  Can handle cross-platform
// line endings and extra whitespace
class UserFileParser {
    public static firstNameColumn: string = 'firstname';
    public static lastNameColumn: string = 'lastname';
    public static emailColumn: string = 'email';

    private readonly _contents: string;
    private _firstNameColIndex: number;
    private _lastNameColIndex: number;
    private _emailColIndex: number;
    private _parsedUsers: UserDetails[];

    constructor(fileContents: string) {
        this._contents = fileContents;
        this._firstNameColIndex = -1;
        this._lastNameColIndex = -1;
        this._emailColIndex = -1;
        this._parsedUsers = [];
        this._parseContent();
    }

    // Returns whether or not the CSV/contents have valid column names
    isValid(): boolean {
        return this._firstNameColIndex !== -1 &&
            this._lastNameColIndex !== -1 &&
            this._emailColIndex !== -1;
    }

    // Returns list of parsed users
    getUsers(): UserDetails[] {
        return this._parsedUsers;
    }

    private _parseContent(): void {
        if (!this._contents) {
            return;
        }

        const rows = this._contents.split(/\r|\n|\r\n/);
        const header = rows.splice(0, 1)[0];
        const columns = header.split(',').map(item => item.trim().toLowerCase());

        this._firstNameColIndex = columns.indexOf(UserFileParser.firstNameColumn);
        this._lastNameColIndex = columns.indexOf(UserFileParser.lastNameColumn);
        this._emailColIndex = columns.indexOf(UserFileParser.emailColumn);

        if (!this.isValid()) {
            return;
        }

        rows.forEach(row => {
            const cols = row.split(',').map(item => item.trim());

            const firstName = cols[this._firstNameColIndex]?.trim();
            const lastName = cols[this._lastNameColIndex]?.trim();
            const email = cols[this._emailColIndex]?.trim();

            if (firstName && lastName && email) {
                this._parsedUsers.push({
                    firstName,
                    lastName,
                    email,
                    roleIds: []
                });
            }
        });
    }
}

export { UserFileParser };
export default UserFileParser;



// WEBPACK FOOTER //
// ./src/utils/userFileParser.ts